export function createModal(content, title, width = null) {
    // Create a unique class name for each modal instance
    const modalClass = `modal-${Math.random().toString(36).substr(2, 9)}`;

    // Modal HTML structure
    const modalHTML = `
<div id="modal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60222] ${modalClass}" style="display: none;">
    <div class="bg-white dark:bg-gray-800 border border-gray-600 rounded-lgx shadow-lg ${width ? width : 'max-w-2xl w-full'} p-2 xs:p-6 overflow-auto max-h-[90vh] ${modalClass}-content">
        <div class="flex justify-between items-center mb-4">
            <h2 class="text-xl font-semibold ${modalClass}-title dark:text-white">${title}</h2>
            <div class="close-modal ${modalClass}-close text-red-400 hover:bg-green-700/40 rounded-full w-8 h-8 flex justify-center items-center cursor-pointer"><i class="fal fa-times text-xl"></i></div>
        </div>
        <div class="modal-body ${modalClass}-body">${content}</div>
    </div>
</div>

    `;

    // Append modal to the body
    $('body').append(modalHTML);

    // Show the modal
    $(`.${modalClass}`).fadeIn('fast');

    // Close modal when the close button is clicked
    $(`.${modalClass}-close`).on('click', function() {
        closeModal(modalClass);
    });

    // Close modal when clicking outside of the modal content
    $(document).on('click', function(event) {
        if ($(event.target).hasClass(modalClass)) {
            closeModal(modalClass);
        }
    });

    // Function to close the modal
    function closeModal(modalClass) {
        $(`.${modalClass}`).fadeOut('fast',function() {
            $(this).remove(); // Remove the modal from DOM
        });
    }
}

